import { Box, BoxProps } from "@mui/system";

const AppContainerWrapper = ({ className = "", ...props }: BoxProps) => (
  <Box className={`min-w-0 max-w-full p-[24px] ${className}`} {...props} />
);

export default AppContainerWrapper;
